export default __webpack_public_path__ + "static/blueprint-white-a48ddd894624871f1014067991308b2a.jpg";